(function () {
    angular
      .module('kareo.ui.shared.directives.k-create-insurance-plan-company', [
        'angucomplete-alt',
        'kareo.ui.shared.directives.validation.input-group',
        'kareo.ui.shared.directives.validation.prevent-form-submit',
        'kareo.ui.shared.directives.templates',
        'kareo.ui.shared.directives.ui-mask',
        'kareo.ui.shared.directives.k-create-insurance-company',
        'kareo.ui.shared.modules.api.insurance-service',
        'kareo.ui.shared.directives.constants.state-codes',
        'kareo.ui.shared.directives.models.insurance-company-plan',
        'kareo.ui.shared.directives.services.enrollments-service',
        'kareo.ui.shared.directives.k-insurance-company-workflow',
        'kareo.ui.shared.modules.featureSet'
      ])
      .directive('kCreateInsurancePlanCompany', kCreateInsurancePlanCompany)
    .run(['$templateCache', function ($templateCache) {
      $templateCache.put('k-create-insurance-plan-company/autocomplete-with-create.html', require('./autocomplete-with-create.pug')());
    }]);

    function kCreateInsurancePlanCompany() {
      return {
        bindToController: true,
        controller,
        controllerAs: 'vm',
        restrict: 'E',
        scope: {
          onSuccessCallback: '&',
          onCancelCallback: '&',
          params: '='
        },
        template: require('./k-create-insurance-plan-company.pug')()
      };
    }

    controller.$inject = ['$scope', '$filter', 'STATE_CODES', 'insuranceService', 'enrollmentsService', 'insuranceCompanyPlan', 'featureSet', 'authenticatedUser'];

    function controller($scope, $filter, STATE_CODES, insuranceService, enrollmentsService, insuranceCompanyPlan, featureSet, authenticatedUser) {
      var vm = this;

      resetState();
      getInsuranceCompanyDetails()

      vm.saving = false;
      vm.deleting = false;
      vm.insuranceCompanyPlan = (vm.params.editPlan) ? angular.copy(vm.params.companyPlan) : insuranceCompanyPlan.newInsuranceCompanyPlan();
      vm.insuranceCompanyPlan.planName = (vm.params.planNameInputValue) ? vm.params.planNameInputValue : vm.insuranceCompanyPlan.planName;
      vm.companySearchURL = insuranceService.getCompanySearchURL();

      vm.addInsurancePlan = addInsurancePlan;
      vm.editInsurancePlan = editInsurancePlan;
      vm.deleteInsurancePlan = deleteInsurancePlan;
      vm.closeCancel = closeCancel;
      vm.allowMultipleInsurances = false;
      featureSet.load().then((features) => {
        vm.useInsuranceCompanyCreationWorkflow = features['dark-feature.insurance-company-creation-workflow'];
      });

      vm.isSysAdmin = authenticatedUser.hasRole("System Administrator");
      vm.isBiller = authenticatedUser.hasRole("Biller");
      vm.isOfficeStaff = authenticatedUser.hasRole("Office Staff");

      initStates();

      vm.insuranceCompanyChanged = function (company) {
        if (!!company) {
          if (angular.equals(company.originalObject, {})) {
            vm.creatingInsuranceCompany = true;
          } else {
            vm.insuranceCompanySelected = company;
          }
        }
      };

      vm.createCompany = function (company) {
        if (company && !angular.equals(company, {})) {
          $scope.$broadcast('angucomplete-alt:changeInput', 'insuranceCompany', company);
        } else {
          $scope.$broadcast('angucomplete-alt:clearInput', 'insuranceCompany');
        }

        vm.creatingInsuranceCompany = false;
      };

      vm.validateZip = function () {
        if (vm.showValidation && (vm.insuranceCompanyPlan.zipCode.length > 0 && vm.insuranceCompanyPlan.zipCode.length < 5)) {
          return false;
        }
        return true;
      }

      function getInsuranceCompanyDetails() {
        if (vm.params.insuranceCompanyId != 0) {
          enrollmentsService.getInsuranceCompany(vm.params.insuranceCompanyId)
          .then((company) => {
            vm.companyName = company.companyName;
          });
        }
      }

      function addInsurancePlan() {
        vm.saving = true;

        if (vm.params.insuranceCompanyId == 0) {
          vm.insuranceCompanyPlan.insuranceCompanyId = vm.insuranceCompanySelected.originalObject.insuranceCompanyId;
        } else {
          vm.insuranceCompanyPlan.insuranceCompanyId = vm.params.insuranceCompanyId;
        }

        enrollmentsService.addInsurancePlan(vm.insuranceCompanyPlan)
        .then((response) => {
          vm.saving = false;
          closeSuccess({ planName: response.planName,
                        insuranceCompanyPlanId: response.insuranceCompanyPlanId,
                        insuranceCompanyId: response.insuranceCompanyId,
                        status: 'saved'});
        }, () => {
          vm.saving = false;
        });
      };

      function editInsurancePlan() {
        vm.saving = true;

        enrollmentsService.updateInsurancePlan(vm.insuranceCompanyPlan)
        .then(() => {
          vm.saving = false;
          closeSuccess({ status: 'updated'});
        }, () => {
          vm.saving = false;
        });
      }

      function deleteInsurancePlan() {
        vm.deleting = true;
        vm.deleteError = false;

        enrollmentsService.deleteInsurancePlan(vm.insuranceCompanyPlan.insuranceCompanyPlanId)
        .then(() => {
          vm.deleting = false;
          closeSuccess({ status: 'deleted'});
        }, (deleteError) => {
          vm.deleting = false;
          vm.deleteError = true;
          vm.errorMessage = deleteError.data.message;
        });
      }

      function closeSuccess(insurancePlan) {
        vm.onSuccessCallback({ plan: insurancePlan });
        resetState();
      };

      function closeCancel() {
        vm.onCancelCallback();
        resetState();
      };

      function resetState() {
        vm.insuranceCompanySelected = {};
        vm.savingInsurancePlan = false;
        vm.errorCreatingPlan = false;
      }

      function initStates() {
        const states = $filter('orderBy')(STATE_CODES, 'stateCode');
        vm.states = states;
      }
    }
  })();